/**
 * 插件安装消息配置
 */
const installMessage = {
  canvas: '安装成功，可在设计/原型文件中使用该插件',
  devMode: '安装成功，可在研发模式中使用该插件',
  common: '安装成功，可在文件中使用该插件',
};

/**
 * 显示插件安装成功消息
 * @param {Object} vueInstance - Vue 实例，用于调用 $message
 * @param {String} editorType - 插件的编辑器类型 (canvas/devMode/其他)
 */
export function giveInstallMessage(vueInstance, editorType) {
  const message = installMessage[editorType];
  if (message) {
    vueInstance.$message.success(message);
  } else {
    vueInstance.$message.success(installMessage.common);
  }
}
